<!--  -->
<template>
  <div>
    <div>
      <!-- <div class="serch_box">
        <div v-if="type === 3">
          <el-input v-model="query.keywords_group" clearable style="width:200px;margin-right:10px" placeholder="请输入群组名字/编号" />
        </div>
        <div v-else-if="type === 5">
          <el-input v-model="query.group_chat_name_rule" clearable style="width:200px;margin-right:10px" placeholder="请输入拉群规则名称" />
        </div>
        <div v-else>
          <el-input v-model="query.employee_no" clearable style="width:200px;margin-right:10px" placeholder="请输入员工编号" />
          <el-input v-model="query.name" clearable style="width:200px;margin-right:10px" placeholder="请输入员工名字" />
        </div>

        <el-button type="primary" style="margin:0px 10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
        <el-tag v-loading="loadingcount" type="danger" size="medium" style="margin-left:10px;font-size: 17px;">预计推送人数：{{ count }}</el-tag>
      </div> -->
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      :row-key="rowKey"
      max-height="550"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        width="55"
        :reserve-selection="true"
        :selectable="selectable"
      />
      <el-table-column
        prop="id"
        label="id"
        align="center"
      />
      <!-- <el-table-column
        prop="video_alias_name"
        label="视频别名"
        align="center"
      /> -->
      <el-table-column
        prop="account_name"
        label="小程序名称"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="app_id"
        align="center"
      />
      <el-table-column
        prop="create_at_text"
        label="创建时间"
        align="center"
      />
      <!-- <el-table-column
        label="操作"
        min-width="100"
        align="center"
        fixed="right"
      >
        <template scope="scope">
          <el-button v-if="scope.row.status==1" type="info" size="small" @click="unbundle(scope.row.id)">解绑小程序</el-button>

        </template>
      </el-table-column> -->
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      :page-sizes="[10,20,50,100]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-button
      type="primary"
      size="mini"
      @click="unbind"
    >解绑</el-button>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { articleBindAppletRecord, articleUnBindApplet } from '@/api/workWechat.js'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        page_size: 10,
        article_id: null
      },
      selectlist: [],
      selectlistsend: [],
      namearr: [],
      grouparr: [],
      rulearr: [],
      type: null,
      strtext: '',
      push_method: null,
      count: null,
      loadingcount: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    async unbind() {
      if (this.selectlist.length === 0) return this.$message.error('请选择解绑小程序')
      // this.$confirm('您确定解绑吗')
      //   .then(async () => {
      //     const ids = this.selectlist.map(v => v.id)
      //     await articleUnBindApplet({ ids })
      //     this.$message({
      //       message: '解绑成功',
      //       type: 'success'
      //     })
      //     this.list()
      //   })
      //   .catch(() => {})
      this.$confirm('您确定解绑吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const ids = this.selectlist.map(v => v.id)
          articleUnBindApplet({
            ids
          }).then(res => {
            console.log(res)
            this.$message({
              type: 'success',
              message: '解绑成功!'
            })
            this.list()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解绑'
          })
        })
    },
    rowKey(row) {
      return row.id
    },
    selectable(row, index) {
      // eslint-disable-next-line eqeqeq
      return row.status != 2 // 通过某个值来进行判断，规定那一行的选择框被禁用
    },
    async list() {
      this.loading = true
      const data = await articleBindAppletRecord(this.query)
      this.tableData = data.data.list.filter(v => v.status !== 2)
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    // async qunum() {
    //   this.loadingcount = true
    //   const data = await expectedMassCustomersxin({
    //     sp_strategy_no: this.query.sp_strategy_no,
    //     push_method: this.push_method
    //   })
    //   this.count = data.data.count
    //   this.loadingcount = false
    //   console.log('data', data)
    // },

    // 分页
    fetchPageSize(e) {
      this.query.page = 1
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.employee_no = null
      this.query.name = null
      this.query.keywords_group = null
      this.query.group_chat_name_rule = null
      this.list()
    },
    send(item) {
      this.query.article_id = item.id
      this.list()
      // this.qunum()
    },
    handleSelectionChange(rows) {
      this.selectlist = rows //
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.serch_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.sdwr {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.gecawe {
  display: inline-block;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.titip {
  margin: 0 auto;
}
</style>
